import { useTranslation } from 'react-i18next';

interface LoadingFallbackProps {
  label?: string;
  fullScreen?: boolean;
}

export default function LoadingFallback({ label, fullScreen }: LoadingFallbackProps) {
  const { t } = useTranslation();

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-sm text-foreground-500">{label || t('common.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-20">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm text-foreground-400">{label || t('common.loading')}</p>
      </div>
    </div>
  );
}